// Import required libraries
import React from "react";
import orderBy from "lodash/orderBy";
import { useTranslation } from "react-i18next";

// Import custom components
import SigviewSingleSelect from "../Common/SigviewSingleSelect";
import SigviewTextField from "../Common/SigviewTextField";

// Import styles

// Import config
import { config } from "../../config/config";

// Import action creators
import {
  addMetricFilter,
  removeMetricFilter,
  changeMetricFilterType,
  changeMetricFilterValue,
  changeMetricFilterMetricId,
} from "../../redux/actions";

// Import utils & data
import { getNewMetricFilterRow } from "../../utils/filtersUtils";
import { getObjectByKey } from "../../utils/timeFiltersUtils";
import { masterTrackGaEvent } from "../../services/ga";

function MetricFiltersRow(props) {
  const { t } = useTranslation();
  const {
    user,
    allFilterTypes,
    rowIndex,
    totalLength,
    maxLimit,
    dispatchMetricFiltersStore,
    showError,
    allData,
    metricFilterRow,
  } = props;

  const { id, uiCompType } = metricFilterRow;

  let Component;

  //Defining required variables
  const showDeleteIconFlag = totalLength > 1;
  const showAddIconFlag =
    maxLimit !== rowIndex + 1 && rowIndex + 1 === totalLength;
  const itemTitle = `Select all rows having`; //hard coded
  const allMetrics = [
    {
      id: "selectMetric",
      name: "Select Metric",
      disabled: true,
    },
    ...orderBy(
      allData.plotlyMetrics.map((row) => ({
        id: row._id,
        name: row.measureTitle,
        disabled: false,
      })),
      ["name"],
      ["asc"]
    ),
  ];

  const handleMetricIdChange = (newValue) => {
    const payload = {
      metricFilterId: id,
      metricFilterMetricId: newValue,
    };
    dispatchMetricFiltersStore(changeMetricFilterMetricId(payload));
  };

  const handleTypeChange = (newValue) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "GlobalFilters",
      action: "MetricFiltersCondition",
      label: getObjectByKey({ value: newValue, data: allFilterTypes }).title,
    });

    const payload = {
      metricFilterId: id,
      metricFilterType: newValue,
    };
    dispatchMetricFiltersStore(changeMetricFilterType(payload));
    //Hard Coded
    //If user changes from between to some other type, reset 2nd value to 0
    if (newValue !== config.hardCoded.metricFilterTypesBetweenId) {
      const payload2 = {
        metricFilterId: id,
        metricFilterKey: "value2",
        metricFilterValue: "0",
      };
      dispatchMetricFiltersStore(changeMetricFilterValue(payload2));
    }
  };

  const handleRowDelete = () => {
    const payload = { metricFilterId: id };
    dispatchMetricFiltersStore(removeMetricFilter(payload));
  };

  const handleValueChange = (key, newValue) => {
    const payload = {
      metricFilterId: id,
      metricFilterKey: key,
      metricFilterValue: newValue,
    };
    dispatchMetricFiltersStore(changeMetricFilterValue(payload));
  };

  const handleAddRow = () => {
    const newMetricFilterRow = getNewMetricFilterRow();
    const payload = { newMetricFilterRow };
    dispatchMetricFiltersStore(addMetricFilter(payload));
  };

  const propsList = {
    itemTitle,
    metricFilterRow,
    allFilterTypes,
    handleTypeChange,
    handleValueChange,
    handleRowDelete,
    handleAddRow,
    handleMetricIdChange,
    showAddIconFlag,
    showDeleteIconFlag,
    allMetrics,
    showError,
    ...metricFilterRow,
  };

  switch (uiCompType) {
    case "singleValueInput":
      Component = <MetricFilterInputRow {...propsList} />;
      break;

    case "multiValueInput":
      Component = <MetricFilterInputRow {...propsList} />;
      break;

    default:
      Component = <p>Undefined component type</p>;
  }

  return Component;
}

export default MetricFiltersRow;

function MetricFilterInputRow(props) {
  const { t } = useTranslation();
  const {
    itemTitle,
    uiCompType,
    allMetrics,
    allFilterTypes,
    showError,
    handleValueChange,
    handleMetricIdChange,
    handleTypeChange,
    showDeleteIconFlag,
    handleRowDelete,
    handleAddRow,
    showAddIconFlag,
    type,
    typeError,
    value1,
    value2,
    metricId,
    metricIdError,
    value1Error,
    value2Error,
  } = props;

  return (
    <div className="advanced-filters-item-container">
      <div className="advanced-filters-item-title-container">
        <p className="advanced-filters-item-title">{t(itemTitle)}</p>
      </div>
      <SigviewSingleSelect
        value={metricId}
        data={allMetrics}
        onChange={handleMetricIdChange}
        error={showError && metricIdError.flag}
        helperText={metricIdError.message}
        minWidth="200px"
        maxWidth="200px"
        margin={{ right: "5px" }}
      />
      <SigviewSingleSelect
        value={type}
        data={allFilterTypes}
        onChange={handleTypeChange}
        error={showError && typeError.flag}
        helperText={typeError.message}
        minWidth="150px"
        margin={{ right: "5px" }}
      />
      <SigviewTextField
        value={value1}
        onChange={(newValue) => handleValueChange("value1", newValue)}
        placeholder="Enter Number"
        error={showError && value1Error.flag}
        helperText={value1Error.message}
        minWidth="140px"
        maxWidth="140px"
        margin={{ right: "5px" }}
        type="number"
      />
      {uiCompType === "multiValueInput" && (
        <>
          <div className="advanced-filters-item-title-container">
            <p className="advanced-filters-item-title">and</p>
          </div>
          <SigviewTextField
            value={value2}
            onChange={(newValue) => {
              console.log(newValue);
              handleValueChange("value2", newValue);
            }}
            placeholder="Enter Number"
            error={showError && value2Error.flag}
            helperText={value2Error.message}
            minWidth="110px"
            maxWidth="110px"
            margin={{ right: "5px" }}
            type="number"
          />
        </>
      )}
      <div
        className={`advanced-filters-item-icon-container ${
          showDeleteIconFlag ? "visible" : "hidden"
        }`}
      >
        <i
          className="material-icons-outlined advanced-filters-item-icon af-delete-icon"
          onClick={handleRowDelete}
        >
          cancel
        </i>
      </div>
      {showAddIconFlag && (
        <div className="advanced-filters-item-icon-container">
          <i
            className="material-icons advanced-filters-item-icon af-add-icon"
            onClick={handleAddRow}
          >
            add
          </i>
        </div>
      )}
    </div>
  );
}
